__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => (typeof console !== "undefined" && console.warn && console.warn(msg));
	var uniqueName = "[name]";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult.catch(handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@agilize/components-core", "1.4.21", () => (Promise.all([__webpack_require__.e(5724), __webpack_require__.e(770), __webpack_require__.e(8005), __webpack_require__.e(212), __webpack_require__.e(7522), __webpack_require__.e(9770), __webpack_require__.e(7445), __webpack_require__.e(8922)]).then(() => (() => (__webpack_require__(90212))))));
			register("@material-ui/core", "4.12.4", () => (Promise.all([__webpack_require__.e(5724), __webpack_require__.e(770), __webpack_require__.e(9524), __webpack_require__.e(7522), __webpack_require__.e(9770), __webpack_require__.e(2801)]).then(() => (() => (__webpack_require__(39524))))));
			register("axios", "0.21.4", () => (__webpack_require__.e(9669).then(() => (() => (__webpack_require__(9669))))));
			register("date-fns", "2.30.0", () => (Promise.all([__webpack_require__.e(1213), __webpack_require__.e(4428)]).then(() => (() => (__webpack_require__(41213))))));
			register("js-cookie", "2.2.1", () => (__webpack_require__.e(6808).then(() => (() => (__webpack_require__(36808))))));
			register("keycloak-js", "11.0.3", () => (__webpack_require__.e(2385).then(() => (() => (__webpack_require__(32385))))));
			register("react-dom", "17.0.1", () => (Promise.all([__webpack_require__.e(3935), __webpack_require__.e(7522)]).then(() => (() => (__webpack_require__(73935))))));
			register("react-hook-form", "6.15.8", () => (Promise.all([__webpack_require__.e(2283), __webpack_require__.e(7522)]).then(() => (() => (__webpack_require__(42283))))));
			register("react-joyride", "2.9.3", () => (Promise.all([__webpack_require__.e(3212), __webpack_require__.e(7522), __webpack_require__.e(9770), __webpack_require__.e(5697)]).then(() => (() => (__webpack_require__(63212))))));
			register("react-router-dom", "5.2.0", () => (Promise.all([__webpack_require__.e(5977), __webpack_require__.e(7522), __webpack_require__.e(3727)]).then(() => (() => (__webpack_require__(73727))))));
			register("react-toastify", "7.0.4", () => (Promise.all([__webpack_require__.e(2132), __webpack_require__.e(7522), __webpack_require__.e(9770)]).then(() => (() => (__webpack_require__(72132))))));
			register("react", "17.0.1", () => (__webpack_require__.e(7294).then(() => (() => (__webpack_require__(67294))))));
			register("styled-components", "5.3.11", () => (Promise.all([__webpack_require__.e(2788), __webpack_require__.e(7522), __webpack_require__.e(8782)]).then(() => (() => (__webpack_require__(12788))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};